module.exports = __webpack_public_path__ + "img/timeless_relic.429a5def.png";